import React from 'react';
import { styled } from '@nykaa/ui-components';
import { useTheme } from 'emotion-theming';
import { getIconStyles } from 'components/Header/helper';

interface BagProps {
  isLight: boolean;
  color?: string;
}

const Icon = styled.svg<{ isLight: boolean; color?: string }>`
  ${({ theme, isLight, color }) => getIconStyles(theme, isLight, color)};
`;

function Bag({ isLight, color }: BagProps) {
  const theme: Theme = useTheme();
  return (
    <Icon
      isLight={isLight}
      color={color}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>ic-bag</title>
      <g
        id="ic-bag"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ic_bag"
          transform="translate(2.000000, 2.000000)"
        >
          <path
            d="M18.5,6.15 L18.5,14.48 C18.5,15.4550796 18.1119716,16.3900771 17.4215488,17.0786238 C16.7311259,17.7671705 15.795076,18.1526569 14.82,18.1500136 L5.18,18.1500136 C4.20492401,18.1526569 3.26887407,17.7671705 2.57845124,17.0786238 C1.8880284,16.3900771 1.5,15.4550796 1.5,14.48 L1.5,6.15 L18.5,6.15 M19,4.65 L1,4.65 C0.44771525,4.65 0,5.09771525 0,5.65 L0,14.48 C0,15.8529036 0.546064795,17.1694311 1.51779176,18.1392821 C2.48951873,19.1091332 3.80709895,19.6526555 5.18,19.65 L14.82,19.65 C16.1929011,19.6526555 17.5104813,19.1091332 18.4822082,18.1392821 C19.4539352,17.1694311 20,15.8529036 20,14.48 L20,5.65 C20,5.09771525 19.5522847,4.65 19,4.65 Z"
            id="Shape"
            fill={color ? color : isLight ? theme.colors.surface : '#000000'}
            fillRule="nonzero"
          ></path>
          <path
            d="M6.4,8.86 L6.4,4.19 C6.33821865,2.13719693 7.94748296,0.420648332 10,0.35 L10,0.35 C10.989402,0.378747467 11.9268069,0.799576623 12.6057792,1.51981235 C13.2847514,2.24004808 13.6496079,3.20062335 13.62,4.19 L13.62,8.86"
            id="Path"
            stroke={color ? color : isLight ? theme.colors.surface : '#000000'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <circle
            id="Oval"
            fill="#000000"
            fillRule="nonzero"
            cx="13.6"
            cy="8.97"
            r="1.1"
          ></circle>
          <circle
            id="Oval"
            fill="#000000"
            fillRule="nonzero"
            cx="6.4"
            cy="8.97"
            r="1.1"
          ></circle>
        </g>
      </g>
    </Icon>
  );
}

export default Bag;
